import { render, staticRenderFns } from "./LoanPayment.vue?vue&type=template&id=32c1e7fd&"
import script from "./LoanPayment.vue?vue&type=script&lang=js&"
export * from "./LoanPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports